<template>
  <div class="imgList">
    <img class="img02" src="../../../../static/img/design/design02.png">
    <img class="img03" src="../../../../static/img/design/design03.png">
    <br/>
    <img class="img01" src="../../../../static/img/design/design01.jpg">
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
      data(){
          return{
              img_left: {},
              img_right:{}
          }
      }
  }
</script>

<style scoped>
  .imgList {
    width: 1080px;
    height: 620px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 0 8px #ffffff;
    margin: auto;
    padding: 50px 5px 50px 50px;
  }

  .img01 {
    width: 400px;
    float: left;

    margin-top: 130px;
  }

  .img02 {
    width: 400px;
    margin-top: 90px;
  }

  .img03 {
    width: 650px;

    float: right;
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Technology/Components/designAbility.vue